<div class="main-container">
  <div class="drop-down-container" [ngClass]="{ disabled: disabled }">
    <!-- <app-loader class="loader" *ngIf="loaderView"></app-loader> -->
    <div class="head">
      <div class="head-title" [ngClass]="{ focus: showDropDownOptions }" [ngStyle]="isButton ? styleObject : {}"
        (click)="toggleDropdown()">
        <div class=" selected-item">
          <img class="icons" *ngIf="icon" src="assets/24x24/{{ icon }}.svg" alt="{{ icon }}" />
          <span class="title" [ngStyle]="{ 'color': isButton ? 'white': '' }">{{ title }}
            <span *ngIf="isButton">+</span>
          </span>
        </div>

        <img class="icons" [src]="'assets/12x12/' + (showDropDownOptions ? 'sort-desc' : 'sort-asc') + '.svg'"
          alt="expand" *ngIf="!isButton" />
      </div>
    </div>

    <div class="options" *ngIf="showDropDownOptions"
      [ngClass]="{ 'is-down': showDropContainerTop,'workspace-fix':createWorkspaceFlag }">
      <ng-container *ngIf="options && options?.length > 0; else noData">
        <ng-container *ngFor="let option of options; let i = index">
          <ng-container *ngIf="(titleName ? option[titleName] : option) !== ''">
            <div class="option" [ngClass]="{ active: i === activeIndex }">
              <div class="option-item" (click)="getOption(option[titleName], i, option[valueName], option)"
                [ngClass]="{ active: i === activeIndex }">
                <p class="option-name" *ngIf="titleName.length > 0" value="option[valueName]">
                  {{ option[titleName] }}
                </p>
                <ng-container *ngIf="titleName.length === 0">
                  <p class="option-name" value="option[valueName]" *ngIf="i !== activeIndex; else otherOptions">
                    {{ option }}
                  </p>
                  <ng-template #otherOptions>
                    <p class="option-name">{{ title | titlecase }}</p>
                    <img src="assets/12x12/check.svg" alt="" srcset="" />
                  </ng-template>
                </ng-container>
                <p class="option-asset-code" *ngIf="hasCaption">
                  {{ option[captionItem] }}
                </p>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-template #noData>
        <div class="option">
          <div class="option-item">
            <p class="option-name">No Data Available</p>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>